// extracted by mini-css-extract-plugin
export var modal = "style-module--modal--CxWhY";
export var modal_outer = "style-module--modal_outer--RJRHY";
export var modal_inner = "style-module--modal_inner--Pp+pS";
export var modal_container = "style-module--modal_container--5ImfV";
export var modal_close = "style-module--modal_close--OVJok";
export var modal_content = "style-module--modal_content--hlxSf";